<template>
    <section class="best-properties-section">
      <div class="triplea-container">
        <div v-if="!isMobile" class="best-properties-main-row">
            <div class="best-properties-cards-bloc">
                <button
                    v-on:click="setActiveTab('alugar-imoveis')"
                    class="best-properties-card bg-1"
                    :class="currentTab === 'alugar-imoveis' ? 'active' : ''"
                >
                    <h2>ALUGAR IMÓVEIS</h2>
                </button>
                <button
                    v-on:click="setActiveTab('comprar-imoveis')"
                    class="best-properties-card bg-2"
                    :class="currentTab === 'comprar-imoveis' ? 'active' : ''"
                >
                    <h2>COMPRAR IMÓVEIS</h2>
                </button>
                <button
                    v-on:click="setActiveTab('bairros-curitiba')"
                    class="best-properties-card bg-3"
                    :class="currentTab === 'bairros-curitiba' ? 'active' : ''"
                >
                    <h2>BAIRROS EM CURITIBA</h2>
                </button>
            </div>
            <div class="best-properties-content-bloc">
                <div class="best-properties-content-title-box">
                    <h2>{{ activeTabData.title }}</h2>
                </div>
                <div class="best-properties-content-list-box">
                    <ul>
                        <li v-for="(search, index) in activeTabData.searchs" :key="index">
                            <a :href="search.link">{{ search.label }}</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div v-if="isMobile" class="best-properties-main-row-mobile">
            <div class="best-properties-cards-bloc">
                <div class="best-properties-card-content-wrapper">
                    <button
                        v-on:click="setActiveTab('alugar-imoveis')"
                        class="best-properties-card bg-1"
                        :class="currentTab === 'alugar-imoveis' ? 'active' : ''"
                    >
                        <h2>ALUGAR IMÓVEIS</h2>
                    </button>
                    <div 
                        class="best-properties-content-list-box"
                        :class="currentTab === 'alugar-imoveis' ? 'showTab' : ''"
                        >
                        <ul>
                            <li v-for="(search, index) in definedTabData('alugar-imoveis').searchs" :key="index">
                                <a :href="search.link">{{ search.label }}</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="best-properties-card-content-wrapper">
                    <button
                        v-on:click="setActiveTab('comprar-imoveis')"
                        class="best-properties-card bg-2"
                        :class="currentTab === 'comprar-imoveis' ? 'active' : ''"
                    >
                        <h2>COMPRAR IMÓVEIS</h2>
                    </button>
                    <div class="best-properties-content-list-box"
                        :class="currentTab === 'comprar-imoveis' ? 'showTab' : ''"
                    >
                        <ul>
                            <li v-for="(search, index) in definedTabData('comprar-imoveis').searchs" :key="index">
                                <a :href="search.link">{{ search.label }}</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="best-properties-card-content-wrapper">
                    <button
                        v-on:click="setActiveTab('bairros-curitiba')"
                        class="best-properties-card bg-3"
                        :class="currentTab === 'bairros-curitiba' ? 'active' : ''"
                    >
                        <h2>BAIRROS EM CURITIBA</h2>
                    </button>
                    <div 
                        class="best-properties-content-list-box"
                        :class="currentTab === 'bairros-curitiba' ? 'showTab' : ''">
                        <ul>
                            <li v-for="(search, index) in definedTabData('bairros-curitiba').searchs" :key="index">
                                <a :href="search.link">{{ search.label }}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </section>
  </template>
  <script>
    import "@/assets/scss/custom/triplea/components/_home_best-properties_section.scss"
    export default {
        data(){
            return{
                currentTab: "alugar-imoveis",
                prepared_searches: {
                'ptBR': [
                    {
                        "label": "Alugar Imóveis",
                        "class": "alugar-imoveis",
                        "title": "Os melhores imóveis para locação",
                        "searchs": [
                            {
                                "link": "/alugar/curitiba",
                                "label": "Alugar em Curitiba"
                            },
                            {
                                "link": "/alugar/sao-jose-dos-pinhais",
                                "label": "Alugar em São José dos Pinhais/PR"
                            },
                            {
                                "link": "/alugar/pinhais",
                                "label": "Alugar em Pinhais/PR"
                            },
                            {
                                "link": "/alugar/colombo",
                                "label": "Alugar em Colombo/PR"
                            },
                            {
                                "link": "/alugar/pato-branco",
                                "label": "Alugar em Pato Branco/PR"
                            },
                            {
                                "link": "/alugar/matinhos",
                                "label": "Alugar em Matinhos/PR"
                            },
                            {
                                "link": "/alugar/guaratuba",
                                "label": "Alugar em Guaratuba/PR"
                            },
                            {
                                "link": "/alugar/balneario-camboriu",
                                "label": "Alugar em Balneario Camboriú/SC"
                            },
                            {
                                "link": "/alugar/itapoa",
                                "label": "Alugar em Itapoá/SC"
                            },
                            {
                                "link": "/alugar/quatro-barras",
                                "label": "Alugar em Quatro Barras/PR"
                            },
                            {
                                "link": "/alugar/campo-largo",
                                "label": "Alugar em Campo Largo/PR"
                            },
                            {
                                "link": "/alugar/fazenda-rio-grande",
                                "label": "Alugar em Fazenda Rio Grande/PR"
                            },
                            {
                                "link": "/alugar/joinville",
                                "label": "Alugar em Joinville/SC"
                            },
                            {
                                "link": "/alugar/balneario-picarras",
                                "label": "Alugar em Piçarras/SC"
                            }
                        ]
                    },
                    {
                        "label": "Comprar Imóveis",
                        "class": "comprar-imoveis",
                        "title": "Os melhores imóveis para comprar",
                        "searchs": [
                            {
                                "link": "/venda/curitiba",
                                "label": "Comprar em Curitiba"
                            },
                            {
                                "link": "/venda/sao-jose-dos-pinhais",
                                "label": "Comprar em São José dos Pinhais/PR"
                            },
                            {
                                "link": "/venda/pinhais",
                                "label": "Comprar em Pinhais/PR"
                            },
                            {
                                "link": "/venda/colombo",
                                "label": "Comprar em Colombo/PR"
                            },
                            {
                                "link": "/venda/pato-branco",
                                "label": "Comprar em Pato Branco/PR"
                            },
                            {
                                "link": "/venda/matinhos",
                                "label": "Comprar em Matinhos/PR"
                            },
                            {
                                "link": "/venda/guaratuba",
                                "label": "Comprar em Guaratuba/PR"
                            },
                            {
                                "link": "/venda/balneario-camboriu",
                                "label": "Comprar em Balneario Camboriú/SC"
                            },
                            {
                                "link": "/venda/itapoa",
                                "label": "Comprar em Itapoá/SC"
                            },
                            {
                                "link": "/venda/quatro-barras",
                                "label": "Comprar em Quatro Barras/PR"
                            },
                            {
                                "link": "/venda/campo-largo",
                                "label": "Comprar em Campo Largo/PR"
                            },
                            {
                                "link": "/venda/fazenda-rio-grande",
                                "label": "Comprar em Fazenda Rio Grande/PR"
                            },
                            {
                                "link": "/venda/joinville",
                                "label": "Comprar em Joinville/SC"
                            },
                            {
                                "link": "/venda/balneario-picarras",
                                "label": "Comprar em Piçarras/SC"
                            }
                        ]
                    },
                    {
                        "label": "Bairros em Curitiba",
                        "class": "bairros-curitiba",
                        "title": "Os melhores bairros de Curitiba",
                        "searchs": [
                            {
                                "link": "/alugar/curitiba/batel",
                                "label": "Imóveis no Batel"
                            },
                            {
                                "link": "/alugar/curitiba/boa-vista",
                                "label": "Imóveis no Boa Vista"
                            },
                            {
                                "link": "/alugar/curitiba/agua-verde",
                                "label": "Imóveis no Água Verde"
                            },
                            {
                                "link": "/alugar/curitiba/tingui",
                                "label": "Imóveis no Tingui"
                            },
                            {
                                "link": "/alugar/curitiba/cristo-rei",
                                "label": "Imóveis no Cristo Rei"
                            },
                            {
                                "link": "/alugar/curitiba/sao-francisco",
                                "label": "Imóveis no São Francisco"
                            },
                            {
                                "link": "/alugar/curitiba/centro",
                                "label": "Imóveis no Centro"
                            },
                            {
                                "link": "/alugar/curitiba/santa-candida",
                                "label": "Imóveis no Santa Cândida"
                            },
                            {
                                "link": "/alugar/curitiba/ahu",
                                "label": "Imóveis no Ahú"
                            },
                            {
                                "link": "/alugar/curitiba/merces",
                                "label": "Imóveis no Mercês"
                            },
                            {
                                "link": "/alugar/curitiba/juveve",
                                "label": "Imóveis no Juvevê"
                            },
                            {
                                "link": "/alugar/curitiba/portao",
                                "label": "Imóveis no Portão"
                            },
                            {
                                "link": "/alugar/curitiba/bigorrilho",
                                "label": "Imóveis no Champagnat"
                            },
                            {
                                "link": "/alugar/curitiba/cajuru",
                                "label": "Imóveis no Cajuru"
                            }
                        ]
                    }
                ],
            },
            }
        },
        computed:{
            activeTabData() {
                return this.prepared_searches.ptBR.find(
                    (tab) => tab.class === this.currentTab
                );
            },
        },
        methods:{
            setActiveTab(newTab) {
                this.currentTab = newTab;
            },
            definedTabData(chosen) {
                return this.prepared_searches.ptBR.find((tab) => tab.class === chosen);
            },
        }
    }
  </script>
  
  
  